













































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  IPrivateSignature,
  getSignatureStatus,
  getSignatureArea,
  setSignature,
  deleteUdid
} from '@/api/developer/developer-private/private'
import {
  getAppList,
  batchDeleteApp,
  changeSeq
} from '@/api/developer/developer-private/company'
import { getWeekAppList, addWeekApp, deleteWeekApp, dragSort } from '@/api/developer/week'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  deepCopy
} from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import Sortable from 'sortablejs'

@Component({
  name: 'DeveloperPirvateApp'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    advEntityId: '',
    advAppName: '',
    vipEntityId: '',
    vipAppName: '',
    page: 1,
    pageCount: 20
  }
  // component data
  tableLoading = false
  loadingText = ''
  tableHeight: number = 500
  private tableData: any[] = []
  private statusList: any[] = []
  private areaList: any[] = []
  private selectedData: any[] = []
  private dateArray: string[] = ['', '']
  private totalCount = 0
  private addFormVisible: boolean = false
  private addParams = {
    advEntityId: '',
    vipEntityId: ''
  }
  private rules: any = {
    advEntityId: [{ required: true, message: '请填写七天签的应用ID', trigger: 'blur' }],
    vipEntityId: [{ required: true, message: '请填写对应的的VIP应用ID', trigger: 'blur' }]
  }
  // lifecycle
  async created() {
    this.getTableData()
    this.getSignatureStatus()
    this.getAreaList()
  }

  mounted() {
    this.rowDrop()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    try {
      this.tableLoading = true
      let res: any = await getWeekAppList(this.params)
      this.tableData = res.data.dataList
      console.log(this.tableData)
      this.totalCount = res.data.pageInfo.totalCount
    } catch (error) {
      this.$message.error(error as string)
    } finally {
      this.tableLoading = false
    }
  }
  async getSignatureStatus() {
    let res: any = await getSignatureStatus()
    this.statusList = res.data.dataList
  }
  async handleExcel() {
    let excelParams = deepCopy(this.params)
    this.loadingText = '正在拼命加载...'
    this.tableLoading = true
    try {
      // let res: any = await getAppList(
      //   Object.assign(excelParams, {
      //     page: 1,
      //     pageCount: 100000
      //   })
      // )
      // if (res.status.code === 0) {
      //   setTimeout(() => {
      //     this['$message'].success('导出成功!')
      //   }, 200)
      // } else {
      //   this['$message'].error('导出失败!')
      //   return
      // }
      const filterVal: string[] = [
        'seq',
        'appId',
        'appName',
        'createDate'
      ]
      const theader: string[] = [
        '签名排序',
        '应用ID',
        '应用名称',
        '创建时间'
      ]
      if (this.selectedData.length <= 0) {
        return this.$message.warning('请选择数据')
      }
      const list = this.tableData
      const data = formatJson(filterVal, list)
      exportJson2Excel(theader, data)
      this['$message'].success('导出成功!')
      ;(this.$refs['multiTable'] as any).clearSelection()
    } catch (error) {
      this['$message'].error(error as string)
    } finally {
      this.tableLoading = false
      this.loadingText = ''
    }
  }
  async getAreaList() {
    let res: any = await getSignatureArea()
    this.areaList = res.data.dataList
  }

  rowDrop() {
    const table = document.querySelector('.el-table__body-wrapper tbody')
    const _this = this
    // table 有值时才能对其进行操作
    if (table) {
      Sortable.create(table, {
        // 拖动结束事件
        handle: '.bars',
        onEnd({ oldIndex, newIndex }: any) {
          // alert('暂无接口')
          if (oldIndex !== newIndex) {
            // eslint-disable-next-line camelcase
            let addr_seq = _this.tableData[oldIndex]['seq']
            // eslint-disable-next-line camelcase
            let new_seq = _this.tableData[newIndex]['seq']
            dragSort({ addr_seq, new_seq }).then((res: any) => {
              _this.$message.success('操作成功')
            }).catch(() => {
              _this.getTableData()
            })
            // console.log(_this.tableData[oldIndex]['seq'])
            // console.log(_this.tableData[newIndex]['seq'])
          }
        }
      })
    }
  }

  handleSeq(oldIndex: number, position: number) {
    let newIndex = oldIndex + position
    if (newIndex >= 0) {
      // eslint-disable-next-line camelcase
      let addr_seq = this.tableData[oldIndex]['seq']
      // eslint-disable-next-line camelcase
      let new_seq = this.tableData[newIndex]['seq']
      console.log(addr_seq, new_seq)
      dragSort({ addr_seq, new_seq }).then((res: any) => {
        this.$message.success('操作成功')
        this.getTableData()
      })
    }
  }
  // handleDateChange(date: string[]) {
  //   this.params.createDateStart = date && date[0]
  //   this.params.createDateEnd = date && date[1]
  // }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params: any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.getTableData()
  }
  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleAdd() {
    this.addFormVisible = true
  }
  handleRandom() {}
  setTableHeight() {
    const filter: any = this.$refs.filter
    if (!filter) {
      return false
    }
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  autoSort() {
    alert('暂无接口')
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.appId)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.appId))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.appId)
    tempSelectList = this.selectedData.map(item => item.appId)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.appId)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  async handleDeleteUdid(item: IPrivateSignature) {
    const { serverArea: area, udid } = item
    let res: any = await deleteUdid({
      clearParam: [{ area, udid }]
    })
    if (res.status.code === 0) {
      this['$message'].success('清除成功')
    } else {
      this['$message'].error('清除失败')
    }
  }
  async handleDeleteUdidAll() {
    let arr: Array<{ appId: string }> = []
    this.selectedData.forEach((item) => {
      arr.push(item.appId)
    })
    // for (let e of arr) {
    //   await deleteApp(e)
    // }
    // this['$message'].success('批量删除成功')
    let ids = arr.join(',')
    console.log(ids)
    let res: any = await batchDeleteApp({
      appId: arr.join(',')
    })
    if (res.status.code === 0) {
      this['$message'].success('批量删除成功')
      this.getTableData()
    } else {
      this['$message'].error('批量删除失败')
    }
  }
  handleFormClose() {
    this.cancelAddForm()
  }
  cancelAddForm() {
    this.addParams = {
      advEntityId: '',
      vipEntityId: ''
    }
    this.addFormVisible = false
  }
  async confirmAddForm() {
    if (!this.addParams.advEntityId) {
      this['$message'].warning('七天签应用ID不能为空')
      return
    }
    if (!this.addParams.vipEntityId) {
      this['$message'].warning('VIP应用ID不能为空')
      return
    }
    let res: any = await addWeekApp(this.addParams)
    let code: number = +res.status.code
    if (code !== 0) {
      this['$message'].error(`添加失败`)
    } else {
      if (res.status.message === 'success') {
        this['$message'].success('添加成功')
      }
      this.addFormVisible = false
      this.getTableData()
    }
  }
  deleteApp(id: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteWeekApp(id)
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }

  async handleEdit(item: any) {
    const { appId, seq } = item
    if (typeof seq === 'string' && seq === '') {
      this['$message'].warning('请输入排序!')
      return false
    } else if (seq <= 0) {
      this['$message'].warning('排序不得小于等于0!')
      return false
    }
    let res: any = await changeSeq({
      appId: appId,
      seq: seq
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
      await this.getTableData()
    } else {
      this['$message'].error('操作失败')
    }
  }

  handleSortChange(val: any) {
    console.log(val.order)
    if (this.tableData.length > 1) {
      if (!val.order || val.order === 'ascending') {
        if (this.tableData[0].seq > this.tableData[this.tableData.length - 1].seq) {
          this.tableData = this.tableData.reverse()
        }
      } else if (val.order === 'descending') {
        if (this.tableData[0].seq < this.tableData[this.tableData.length - 1].seq) {
          this.tableData = this.tableData.reverse()
        }
      }
    }
  }

  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach((item) => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
